
  // Check if the current page is the main collections page
  if (window.location.pathname === '/collections') {

    // Set meta title
    document.title = 'Shop Breathable Cotton Tees, Polos T Shirts & Shorts Online at Bombased';
    
    // Set new meta description
    let metaDescription = document.querySelector('meta[name="description"]');
    if (!metaDescription) {
      metaDescription = document.createElement('meta');
      metaDescription.setAttribute('name', 'description');
      document.head.appendChild(metaDescription);
    }
    metaDescription.setAttribute('content', 'Shop premium plain t-shirts, polo neck tees and cotton shorts for men and women at Bombased. Unisex styles,solid colours and easy 30 day returns. Buy online today.');
  }
